module.exports = __webpack_public_path__ + "assets/6-tech-sales-jobs.576cdb54.png";